import { useRef } from "react";
import { motion, useMotionValue, useScroll, useSpring, useTransform } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const Line = ({ children, delay }) => (
  <span className="line">
    <motion.span initial={{ y: "110%" }} animate={{ y: "0%" }} transition={{ duration: 1.1, delay, ease }}>
      {children}
    </motion.span>
  </span>
);

const Fade = ({ children, delay, className, testId }) => (
  <motion.div className={className} data-testid={testId} initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay, ease }}>
    {children}
  </motion.div>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const gateY = useTransform(scrollYProgress, [0, 1], [0, 140]);
  const contentY = useTransform(scrollYProgress, [0, 1], [0, 60]);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotY = useSpring(useTransform(mx, [-0.5, 0.5], [-9, 9]), { stiffness: 60, damping: 18 });
  const rotX = useSpring(useTransform(my, [-0.5, 0.5], [7, -7]), { stiffness: 60, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };

  return (
    <header className="hero" ref={ref} onMouseMove={onMove} data-testid="hero-section">
      <div className="hero-glow" />
      <motion.div className="hero-gate" style={{ y: gateY, rotateX: rotX, rotateY: rotY }}
        initial={{ opacity: 0, scale: 0.92 }} animate={{ opacity: 0.13, scale: 1 }} transition={{ duration: 2.2, ease }}>
        <img src="/igc-crest.png" alt="" data-testid="hero-crest-bg" />
      </motion.div>
      <div className="hero-grain" />
      <motion.div className="hero-inner" style={{ y: contentY }}>
        <Fade delay={0.1}>
          <div className="eyebrow" data-testid="hero-badge">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><circle cx="5" cy="5" r="4.5" stroke="currentColor" strokeWidth="1" /><path d="M3 5.5l1.5 1.5L7 4" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" /></svg>
            U.S. Veteran Owned &amp; Operated
          </div>
        </Fade>
        <h1 data-testid="hero-headline">
          <Line delay={0.25}>Free Credit Repair.</Line>
          <Line delay={0.42}><em>If You Qualify.</em></Line>
        </h1>
        <Fade delay={0.8}>
          <p className="lead">We are a military-led firm giving back to the community. Credit repaired, funding secured, assets protected — start to finish, at zero cost to you if you meet the criteria.</p>
        </Fade>
        <Fade delay={1.0}>
          <div className="zero-badge" data-testid="hero-zero-badge">$0 Upfront &nbsp;·&nbsp; Zero Out of Pocket &nbsp;·&nbsp; If You Qualify</div>
        </Fade>
      </motion.div>
    </header>
  );
};
